import { AttributeIdentifiers } from "@lyfegen-platform/graphql-schema/models";
import { useField } from "formik";
import { useEffect } from "react";
import * as Yup from "yup";
import { GeneralFieldController } from "./general-field-controller";
import { ControlState } from "../models/flexible/control-state";

function DateSequenceEffect() {
	const [intendedStartDate, , { setValue: setIntendedStartDate }] = useField(AttributeIdentifiers.IntendedStartDate);
	const [requestReceiptDate] = useField(AttributeIdentifiers.RequestReceiptDate);

	useEffect(() => {
		if (!!requestReceiptDate.value && !!intendedStartDate.value && requestReceiptDate.value > intendedStartDate.value) {
			setIntendedStartDate("");
		}
	}, [requestReceiptDate.value]);

	return null;
}

export class IntendedStartDateFieldController extends GeneralFieldController {
	override createValidationRule(initialData: unknown, translation: (key: string) => string): Yup.AnySchema {
		return (super.createValidationRule(initialData, translation) as Yup.DateSchema)
			.max(new Date(), translation("cannot-be-greater-than-today"))
			.when([AttributeIdentifiers.RequestReceiptDate], ((requestReceiptDate: Date, schema: Yup.DateSchema<any>) =>
				requestReceiptDate
					? schema.min(requestReceiptDate, `${translation("cannot-be-less-than")} ${translation("requestReceiptDate")}`)
					: schema) as any)
			.nullable();
	}

	override useControlProps(path: string) {
		return {
			cannotBeFuture: true,
		};
	}

	override mapInitialValue(value: unknown): unknown {
		return value || this.parent.context.startingPoint?.data[AttributeIdentifiers.IntendedStartDate as any] || "";
	}

	override useControlState(): ControlState {
		return this.parent.context.noPatients && this.parent.context.noPatients > 0 ? "hidden" : "enabled";
	}
	renderBeforeContent(): React.ReactElement {
		return <DateSequenceEffect />;
	}
}
